import moment from "moment";
import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { ViewLink } from "../_components/AdminRowActions";

const USER_STATUS = {
  PENDING_VERIFICATION: { tone: "warning", text: "Pending Verification" },
  ACTIVE: { tone: "success", text: "Approved" },
  DEACTIVE: { tone: "danger", text: "Deactive" },
};

const getStatus = (status) => USER_STATUS[status] || { tone: "neutral", text: "-" };

const IndividualUserItem = ({ user: { _id, name, email, date, status }, count }) => {
  const statusMeta = getStatus(status);

  return (
    <tr>
      <td className={cellClass}>{count + 1}</td>
      <td className={cellClass}>{name}</td>
      <td className={cellClass}>{email}</td>
      <td className={cellClass}>
        <AdminBadge tone={statusMeta.tone}>{statusMeta.text}</AdminBadge>
      </td>
      <td className={cellClass}>-</td>
      <td className={`${cellClass} tw:whitespace-nowrap`}>{moment(date).locale("en").format("YYYY/MM/DD")}</td>
      <td className={stickyCellClass}>
        <AdminRowActions>
          <ViewLink to={`/admin/userlist-individual/${_id}`} label="View user" />
        </AdminRowActions>
      </td>
    </tr>
  );
};

export default IndividualUserItem;
